import { withMotion } from '@hoc/withMotion';
import { FocusScope } from '@react-aria/focus';
import { MotionConfig } from 'framer-motion';
import * as React from 'react';
import S from './Accordion.styles';
import { AccordionProvider } from './Context/Context';
import AccordionItem from './Item/Item';
const AccordionComponent = (props) => {
    return (React.createElement(MotionConfig, { transition: { duration: 0.3, ease: 'easeOut' } },
        React.createElement(AccordionProvider, { initialId: props.initialId ?? '' },
            React.createElement(FocusScope, null,
                React.createElement(S.Container, null, props.children)))));
};
export const Accordion = Object.assign(withMotion(AccordionComponent), { Item: AccordionItem });
export default Accordion;
